import * as React from "react";
import SideMenuBar from "./SideMenuBar";
import NavBar from './NavBar';

export default function ConnectYourBank() {
  return (
    <div>
        <NavBar/>
        <SideMenuBar activeClass={"connectBank"}/>
    </div>
  );
}
